import React, { forwardRef } from 'react';
import SearchInput from '../ui/SearchInput';

const Search = forwardRef(function Search({ onChange, onClear, onPageReset, ...props }, ref) {
  const handleChange = (event) => {
    onChange?.(event);
    onPageReset?.();
  };

  const handleClear = onClear ? () => {
    onClear();
    onPageReset?.();
  } : undefined;

  return <SearchInput ref={ref} {...props} onChange={handleChange} onClear={handleClear} />;
});

export default Search;
